// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"201":"fac179f4","452":"d52de9c0","829":"bae36f03"}[chunkId] + ".css";
};